/**
 * Browser Supabase Client Options
 *
 * Centralizes browser Supabase client setup so every client-side
 * initialization path uses the same auth lock behavior.
 *
 * Primary responsibilities:
 * - Share the one browser Supabase client (with Safari-safe auth.lock)
 * - Prevent a second createBrowserClient from racing @supabase/ssr's singleton
 *   into navigatorLock on Safari (UnavailableError)
 *
 * Dependencies:
 * - lib/supabase/browser-client
 */

import type { SupabaseClient } from '@supabase/supabase-js'

import { getBrowserSupabaseClient } from '@/lib/supabase/browser-client'
import { Database } from '@/supabase/types'

export const createBrowserSupabaseClient = () =>
  getBrowserSupabaseClient() as SupabaseClient<Database>
